import { render } from "./hotQuesManager.vue?vue&type=template&id=38d4d940"
import script from "./hotQuesManager.vue?vue&type=script&lang=js"
export * from "./hotQuesManager.vue?vue&type=script&lang=js"

import "./hotQuesManager.vue?vue&type=style&index=0&id=38d4d940&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__